module.exports = __webpack_public_path__ + "img/cx9-gt-19.71f2a4f4.png";